import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://automobileaz.be/api/v1' 
    : 'http://127.0.0.1:8000/api/v1');

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

const transMap = {
    // English -> French
    'manual': 'Manuelle',
    'automatic': 'Automatique',
    'diesel': 'Diesel',
    'petrol': 'Essence',
    'gasoline': 'Essence',
    'electric': 'Électrique',
    'hybrid': 'Hybride',
    'lpg': 'GPL',
    'suv': 'SUV',
    'sedan': 'Berline',
    'saloon': 'Berline',
    'hatchback': 'Compacte',
    'estate': 'Break',
    'station wagon': 'Break',
    'coupe': 'Coupé',
    'convertible': 'Cabriolet',
    'cabriolet': 'Cabriolet',
    'van': 'Monospace',
    'mpv': 'Monospace',
    'minivan': 'Monospace',
    'grey': 'Gris',
    'gray': 'Gris',
    'black': 'Noir',
    'white': 'Blanc',
    'blue': 'Bleu',
    'red': 'Rouge',
    'silver': 'Argent',
    'brown': 'Marron',
    'green': 'Vert',
    'yellow': 'Jaune',
    'beige': 'Beige',
    'orange': 'Orange',
    'gold': 'Or',
    'bronze': 'Bronze',
    'metallic': 'Métallisée',
    'solid': 'Unie',
    'used': 'Occasion',
    'new': 'Neuf',
    'accident-free': 'Non accidenté',
    'accidented': 'Accidenté',
    
    // Dutch -> French
    'handgeschakeld': 'Manuelle',
    'automaat': 'Automatique',
    'benzine': 'Essence',
    'personenwagen': 'Berline',
    'terreinwagen': 'SUV/4x4',
    'bestelwagen': 'Camionnette',
    'stationwagen': 'Break',
    'cabrio': 'Cabriolet',
    'metaalkleur': 'Métallisée',
    'grijs': 'Gris',
    'zwart': 'Noir',
    'wit': 'Blanc',
    'blauw': 'Bleu',
    'rood': 'Rouge',
    'zilver': 'Argent',
    'bruin': 'Marron',
    'groen': 'Vert',
    'geel': 'Jaune',
    'oranje': 'Orange',
    'brons': 'Bronze',
    'nieuw': 'Neuf',
    'ongevalvrij': 'Non accidenté'
};

const translateToFrenchValue = (val) => {
    if (typeof val !== 'string') return val;
    const lower = val.toLowerCase().trim();
    if (transMap[lower]) return transMap[lower];
    return val;
};

const translateObject = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) {
        return obj.map(translateObject);
    }
    const fieldsToTranslate = [
        'transmission_name',
        'fuel_type_name',
        'exterior_color',
        'body_style_name',
        'usage_category_name',
        'category_name',
        'paint_type'
    ];
    const newObj = { ...obj };
    for (const key in newObj) {
        if (fieldsToTranslate.includes(key)) {
            newObj[key] = translateToFrenchValue(newObj[key]);
        } else if (typeof newObj[key] === 'object') {
            newObj[key] = translateObject(newObj[key]);
        }
    }
    return newObj;
};

api.interceptors.response.use((response) => {
    if (response.data) {
        response.data = translateObject(response.data);
    }
    return response;
});

export const vehicleApi = {
    getAll: (params = {}) => api.get('/vehicles', { params }),
    getById: (id) => api.get(`/vehicles/${id}`),
    getBySlug: (slug) => api.get(`/vehicles/slug/${slug}`),
    getFilterOptions: () => api.get('/vehicles/filter-options'),
    getCompareOptions: () => api.get('/vehicles/compare-options'),
    compare: (ids) => api.get('/vehicles/compare', { params: { ids } }),
    search: (query) => api.post('/vehicles/search', { query }),
    autocomplete: (query) => api.get('/vehicles/search/autocomplete', { params: { query } }),
};

export const contactApi = {
    send: (data) => api.post('/contact', data),
};

export default api;
